// Main Controller
angular.module("screensApp").controller("MainController", function ($scope, $rootScope, $q, MainService, ScriptLoaderService, BiometryService, AutoCaptureService, VerificationService) {

  /**
   * Sync server time with local time
   */
  $rootScope.getTimeDiff = function () {
    return $q(function (resolve, reject) {
      MainService.getServerTime()
        .success(function (data) {
          var serverTime = moment(data).valueOf(),
            deviceTime = moment().valueOf();

          // Save time difference
          $rootScope.timeDiff = deviceTime - serverTime;

          // Usage
          //var timestamp = moment().valueOf() - $rootScope.timeDiff;
          //self.dateTime = new Date(timestamp);

          resolve("Saved");
        })
        .error(function (err) {
          $rootScope.timeDiff = 0;
          reject("Error saving data!");
        });
    });
  };

  /**
   * Get difference between two dates (seconds)
   */
  $rootScope.getSecondsDiff = function (time1, time2) {
    time1 = moment(time1.split("/").join(""));
    time2 = moment(time2);
    return Math.ceil(moment.duration(time1.diff(time2)).asSeconds());
  };

  /**
   * Update Labels by actual language
   */
  $rootScope.updateLabels = function () {
    if (!$rootScope.labels) {
      // Get labels
      MainService.getLabels()
        .success(function (data) {
          $rootScope.labels = data;
        })
        .finally(function () {
          $rootScope.winnersLabel = $rootScope.labels.winners[$rootScope.config.LanguageId];
        });
    } else {
      $rootScope.winnersLabel = $rootScope.labels.winners[$rootScope.config.LanguageId];
    }
  };

  $rootScope.language = function (language) {
    $rootScope.setLanguage(language);
  };

  /**
   * Show/hide prematch statistics
   * @param data
   */
  $rootScope.togglePrematch = function (data, forcedClose) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: togglePrematch() data: ' + JSON.stringify(data) + ' forcedClose: ' + forcedClose);
    if (forcedClose || !(data && "screenShow" in data)) {
      // V pripade aktivneho quickbet okna a sucasne zapnuteho LIVE prichadza event listenTopScreen 'togglePrematch' pri automatickom reloade plachty
      // => ma vypnut vsetko okrem QB
      $rootScope.hideAllExcept('QuickbetContainer');
      return;
    }
    // Load prematch (h2h and analysis)

    $rootScope.hideAllExcept('PrematchAnalysis');
    $rootScope.loadPrematchAnalysis(data);
  };

  /**
   * Show/hide virtual games
   * @param data
   */
  $rootScope.toggleVirtuals = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleVirtuals() data: ' + JSON.stringify(data));
    if (data.gameID == "0" || data.gameID == 0 || data.leagueID == 0 || !data.screenShow) {
      $rootScope.hideAllExcept();
      return;
    }
    $rootScope.hideAllExcept('Virtuals');
    // Show Virtuals
    $rootScope.showVirtuals(data);
    return;
  };

  /**
   * Show/hide virtual games
   * @param data
   */
  $rootScope.toggleVirtualsEvona = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleVirtualsEvona() data: ' + JSON.stringify(data));
    if (!data.screenShow && !data.Events) {
      $rootScope.hideAllExcept();
      return;
    }
    
    $rootScope.hideAllExcept('VirtualsEvona');
    // Show Virtuals Evona
    $rootScope.showVirtualsEvona(data);
    return;
  };

  /**
   * Show/hide virtual games
   * @param data
   */
  $rootScope.virtualsEvonaHub = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: virtualsEvonaHub() data: ' + JSON.stringify(data));
    if (data) {
      if (data.streamUrl) {
        // hubData obsahujuce video url (Medzi Betstop-om a zaciatkom zapasu)
        $rootScope.processEvonaUrls(data);
      } else {
        $rootScope.processEvonaBetStop(data);
      }
    }
    return false;
  };

    /**
   * Show/hide lottery games
   * @param data
   */
    $rootScope.toggleLottery = function (data) {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleLottery() data: ' + JSON.stringify(data));
      if (data.gameID == "0" || data.gameID == 0 || data.leagueID == 0 || !data.screenShow) {
        $rootScope.hideLottery();
        return;
      }
      // Show Lottery
      $rootScope.hideHelpSRT();
      $rootScope.hideBetRadarStats();
      $rootScope.hideTeamAnalysis();
      $rootScope.hideStream();
      $rootScope.hideVirtuals();
      $rootScope.hideVirtualsEvona();
  
      $rootScope.showLottery(data);
      return;
    };

  /**
   * Show Jackpot
   */
  $rootScope.toggleJackpot = function () {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleJackpot()');
    $rootScope.hideAllExcept('JackpotContainer');
    $rootScope.showJackpotContainer();
    return;
  };

  /**
   * Show/hide Jackpot
   */
  $rootScope.jackpotChanged = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: jackpotChanged() data: ' + JSON.stringify(data));
    $rootScope.jackpotDataChanged(data);
    return;
  };

  /**
   * Show/hide Quickbet
   */
  $rootScope.toggleQuickbet = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleQuickbet() data: ' + JSON.stringify(data));
    if (data.token !== false) {
      $rootScope.hideAllExcept('QuickbetContainer');
      // Show Quickbet
      $rootScope.showQuickbetContainer(data);
      return;
    } else {
      $rootScope.hideAllExcept();
      return;
    }
  };

  /**
   * Betradar Communication between Quickbet control and Quickbet video
   */
  $rootScope.quickbetControl = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: quickbetControl() data: ' + JSON.stringify(data));
    $rootScope.quickbetVideoControl(data);
    return;
  };

  /**
   * Show/hide team analysis
   * @param data
   */
  $rootScope.toggleTeamAnalysis = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleTeamAnalysis() data: ' + JSON.stringify(data));
    if (!data || !data.regionID || !data.teamOrder || data.regionID === 0 || data.screenShow === false) {
      $rootScope.hideAllExcept();
      return;
    }
    $rootScope.hideAllExcept('TeamAnalysis');
    $rootScope.showTeamAnalysis(data);
  };

  /**
   * Show/hide matchtracker
   * @param data
   */
  $rootScope.toggleMatchtracker = function (data, forcedClose) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleMatchtracker() data: ' + JSON.stringify(data) + ' forcedClose: ' + forcedClose);
    if (forcedClose || data.eventID == false || data.eventID == 0 || data.eventID == null || !data.eventID) {
      $rootScope.hideAllExcept();
      return;
    }

    $rootScope.hideAllExcept('Matchtracker');
    // Show matchtracker
    $rootScope.showMatchtracker(data);

    return;
  };

  // Jednotne schovavanie konkurencnych obrazoviek, pripadne vsetkych: "$rootScope.hideAllExcept()"
  $rootScope.hideAllExcept = function (excludeScreen) {

    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideOtherScreens() element: ' + excludeScreen);
    
    // Elements to hide when showing specific element
    var screensToHide = [
      'Matchtracker',
      'QuickbetContainer',
      'Stream',
      'PrematchContainer', 
      'Virtuals',
      'VirtualsEvona',
      'TeamAnalysis',
      'HelpSRT',
      'BetRadarStats',
      'Analysis',
      'Lottery'
    ];
    // Elementy ktorych sa netyka schovanie
    // var screensToPreserve = [
    //   'Biometry',
    //   'Document'
    // ];
    // Remove current element from array
    screensToHide = screensToHide.filter(el => el !== excludeScreen);

    // Hide elements
    screensToHide.forEach(el => $rootScope[`hide${el}`]());
  }

  /**
   * Show/hide matchtracker
   * @param data
   */
  $rootScope.matchTrackerControl = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: matchTrackerControl() data: ' + JSON.stringify(data));
    $rootScope.matchTrackerControlExecute(data);
    return;
  };

  /**
   * Show/hide stream
   * @param data
   */
  $rootScope.toggleStream = function (data, forcedClose) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleStream() data: ' + JSON.stringify(data) + ' forcedClose: ' + forcedClose);
    if (forcedClose || !data.eStreamID || data.eStreamID == false || data.eStreamID == 0 || data.eStreamID == null) {
      $rootScope.hideAllExcept();
      return;
    }
    $rootScope.hideAllExcept('Stream');
    // Show Virtuals
    if (data.provider && data.provider === "MTX" && data.eStreamID.includes("twitch")) {
      // different approach for twitch
      return false;
    } else if (data.provider && data.provider === "MTX") {
      $rootScope.showStreamMTX(data);
    } else {
      $rootScope.showStream(data);
    }
    return;
  };

  $scope.showHelpSRT = function () {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: showHelpSRT()');
    $rootScope.showHelpSRT();
  };

  $scope.hideHelpSRT = function () {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: hideHelpSRT()');
    $rootScope.hideHelpSRT();
  };

  $rootScope.biometryResolve = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: biometryResolve() data: ' + JSON.stringify(data));
    if ($rootScope.config.BiometryLogin && data) {
      // Hide necessary containers
      // Banners, video banners, jackpots are still rendered on background
      $rootScope.hideAllExcept();
      // Zrusi pripadne aktivne requesty na biometricke overenie pre zobrazenie cisla karticky pin-u
      VerificationService.cancelActiveRequests();
      if (data.state) {
        // Fix stavu kedy pri opakovanom biometrickom prihlasovani zobrazi na vrchnej obrazovke neuspesnu ikonu bez texu a na spodnej obrazovke hlasku ako pri neuspesnom privateAccess
        data.credentials && AutoCaptureService.setAutoCaptureState(data.credentials);
        switch (data.state) {
          case "success":
          case "gamblingProhibitedPlayer":
          case "unregisteredPlayer":
            BiometryService.setBiometryPause(true);
            BiometryService.clearBiometryTimeout();
            $rootScope.showBiometry(data);
            // Pocas "jednorazoveho onboardingu" po uspesnom nasnimani selfie nechceme aby sa po uplynuti settings.biometry.hideTimeout informacia skryvala
            if (!(AutoCaptureService.isOnboardingInProgress() && data.state === "success")) {
              BiometryService.setBiometryTimeout(function() {
                $rootScope.hideBiometry();
                // Nastavujem stavovu premennu lebo predpokladam ze onboarding proces sa konci uspesnym skenovanim tvare
                // nastavujem ju az tu lebo pre onboarding su ine texty v html a potrebujem ich vidiet az do schovania tejto obrazovky
                AutoCaptureService.setAutoCaptureState(false);
              }, $rootScope.settings.biometry.hideTimeout);
            }
            break;
          case "manyPlayers":
          case "failed":
            BiometryService.setBiometryPause(true);
            BiometryService.clearBiometryTimeout();
            $rootScope.showBiometry(data);
            BiometryService.setBiometryTimeout(function() {
              $rootScope.config.DebugJsConsoleLogEnabled && console.trace('# INFO: biometryResolve() setBiometryTimeout() reached');
              if (AutoCaptureService.isOnboardingInProgress()) {
                // Ak sa jedna o onboarding neuspesnu selfie tak hlasku o neuspesnosti chceme zobrazovat cely cas onboardingu
                $rootScope.stopBiometry();
              } else if (AutoCaptureService.getAutoCaptureState() === AutoCaptureService.faceCaptureStates.privateAccess) {
                // Pripad kedy timeut sposobi connection error pre private access. Posleme informaciu o neuspesnosti na webApp a na screenApp zobrazime info o neuspesnosti
                $rootScope.BottomScreen("biometryAutentificationPrivateAccess", { state: "failed", info: "setBiometryTimeout() reached" } );
              } else {
                $rootScope.hideBiometry();
              }
            }, (data.info? $rootScope.settings.biometry.hideTimeoutLong: $rootScope.settings.biometry.hideTimeout));
            break;
          case "hideBiometry":
          case "canceled":
            $rootScope.hideBiometry();
            break
          case "continuing":
          default:
            $rootScope.showBiometry(data);
            break;
        }
      }
    } else {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: Biometry disabled BiometryLogin: ' + $rootScope.config.BiometryLogin);
      return;
    }
  };

  /**
  * Login player by biometry on top
  */
  $scope.biometryLogin = function(data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: biometryLogin()');
    if (AutoCaptureService.isOnboardingInProgress()) {
        $rootScope.hideDocument(true);
    } else if (data.credentials === AutoCaptureService.faceCaptureStates.privateAccess) {
        AutoCaptureService.setAutoCaptureState(AutoCaptureService.faceCaptureStates.privateAccess);
        BiometryService.setRequestorPlayerID(data.playerID);
    } else {
        AutoCaptureService.setAutoCaptureState(AutoCaptureService.faceCaptureStates.biometry);
    }
    if (data && data.loginBtnTimeStamp) {
      // Save timestamp of login button
      BiometryService.setBiometryLoginBtnTimeStamp(data.loginBtnTimeStamp);
    }
    $rootScope.biometryLoginOnTop();
  }

  /**
  * Register player by biometry on top
  */
  $scope.autoCaptureOnboarding = function(data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: autoCaptureOnboarding()');
    if ($rootScope.config.BiometryLogin && data && !AutoCaptureService.isOnboardingInProgress()) {
      // Hide necessary containers
      // Banners, video banners, jackpots are still rendered on background
      $rootScope.hideAllExcept();
    }
    $rootScope.autoCaptureOnboarding(data);
  }

  $rootScope.toggleBetRadarStats = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleBetRadarStats() data: ' + JSON.stringify(data));
    if (data) {
      // BetRadar statistiky sa zobrazia pre ligu: ak existuje seasonID, tabulka s rovnakym seasonID nieje zobrazena, nieje v zozname vylucenych sportov
      if (data.screenFor == "league" && data.seasonID && data.seasonID != $rootScope.settings.betRadarStats.actualSeasonID && !$rootScope.settings.betRadarStats.bannedSportIDs.includes(data.sportID)) {
        $rootScope.hideAllExcept('BetRadarStats');
        $rootScope.showBetRadarStats(data);
      } else if (!data.seasonID || !data.screenShow || data.screenFor == "sport" || data.screenFor == "region") {
        // V pripade aktivneho quickbet okna a sucasne zapnuteho LIVE prichadza event listenTopScreen 'togglePrematch' pri automatickom reloade plachty
        // => ma vypnut vsetko okrem QB
        $rootScope.hideAllExcept('QuickbetContainer');
      }
    }
  };

  $rootScope.loadVideo = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: loadVideo() data: ' + JSON.stringify(data));
    // Ak nie je viditeľný iný obsah nad videom 
    if ($rootScope.topMostContent == '') $rootScope.showVideo(data);
  };
  /**
   * Show/hide vlc
   * @param data
   */
  $rootScope.toggleVlc = function (data, forcedClose) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleVlc() data: ' + JSON.stringify(data) + ' forcedClose: ' + forcedClose);
    if ($rootScope.config.Country == "SVK" || $rootScope.config.Country == "STAGING") {
      if (forcedClose || data.qrCode === false) {
        $rootScope.hideVlc();
        return;
      }
      // Show Vlc
      $rootScope.showVlc(data);
      return;
    }
    return false;
  };

  /**
   * Show/hide Toast Notification
   * @param data
   */
  $rootScope.toggleToastNotification = function (data) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: toggleToastNotification() data: ' + JSON.stringify(data));
    if (data.id) {
      if (data.show === true) {
        $rootScope.showToastNotification(data);
      } else {
        $rootScope.hideToastNotification(data);
      }
    }
    return;
  };

  /**
   * Load banners
   * @param data
   */
  $rootScope.loadBanners = function (data) {
    // Sync datetime with server every time, when we're loading banners
    $rootScope.getTimeDiff().finally(function () {
      if ($rootScope.config.JackpotBetTypes && $rootScope.config.JackpotBetTypes.length) {
        $rootScope.loadJackpotData().then(function (jackpotData) {
          _initBanners(data, jackpotData);
        });
      } else {
        _initBanners(data);
      }
    });
  };

  $scope._showVirtuals = function (type) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: _showVirtuals() type: ' + type);
    if (type == 0) $rootScope.hideVirtuals();
    else $rootScope.showVirtuals(type);
  };

  /**
   * @param banner
   * @returns {boolean}
   */
  function isActual(banner) {
    var timestamp = moment().valueOf() - $rootScope.timeDiff,
      now = moment(timestamp).valueOf(),
      start = moment(banner.Start).valueOf(),
      end = moment(banner.End).valueOf();
    showVLC = true;
    if (!$rootScope.settings.vlc.show && banner.Link.includes("rvo")) {
      // nezobrazena lista vlc && rvo banner
      showVLC = false;
    }
    return start <= now && end >= now && showVLC;
  }

  /**
   * @param bannerObject
   * @param jackpotData
   */
  function addJackpotBetweenbanners(bannerObject, jackpotData) {
    if (!bannerObject.length) {
      bannerObject = new Array({
        BodyText: "",
        Duration: 0.001,
        EventDate: null,
        EventID: null,
        EventName: null,
        HeaderText: "",
        LimitAge: false,
        Link: "",
        ShowWinners: false,
        Tags: null,
      });
    }
    var bannersWithJackpots = [];
    bannerObject.forEach(function (banner) {
      bannersWithJackpots.push(banner);
      if (jackpotData.length) {
        bannersWithJackpots.push(Object.assign({},
          {
            IsJackpot: true,
            Duration: 60,
            data: {
              screenShow: true,
              leagueID: null,
              channelID: 0,
            }
          })
        );
      }
    });
    return bannersWithJackpots;
  }

  /**
   * @param data
   * @private
   */
  function _initBanners(data, jackpotData) {

    if (data.DefaultAndVideo) {
      // Remove non actual banners && refactor JSON structure
      $rootScope.banners = data.DefaultAndVideo.filter(isActual).map(function (banner) {
        return reformatBanner(banner);
        // return banner;
      });

      $rootScope.settings.defaultBanner.show = false;

      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: _initBanners() banners: ' + JSON.stringify($rootScope.banners));


      // Start displaying data
      $rootScope.slideIndex = 0;
      $rootScope.bannersListing();
    }

    if (data.SpecialAndVideo && data.SpecialAndVideo.Banners) {
      if (actualCampaign(data.SpecialAndVideo.From, data.SpecialAndVideo.To)) {
        // Remove non actual banners && refactor JSON structure
        $rootScope.customBanners = data.SpecialAndVideo.Banners.filter(isActual).map(function (banner) {
          // Types of banners:
          if (banner.IsVideo) {
            // Video
            return reformatVideo(banner);
          } else {
            // Others - banners
            return reformatBanner(banner);
          }
        });

        if (jackpotData && jackpotData.length) {
          $rootScope.customBanners = addJackpotBetweenbanners($rootScope.customBanners, jackpotData);
        }

        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: _initBanners() customBanners: ' + JSON.stringify($rootScope.customBanners));

        $rootScope.customBannersListing();
      }
    }
  }

  reformatVideo = function (banner) {
    if (!banner.Link) {
      banner.VideoLink = $rootScope.settings.video.defaultUrl;
    } else {
      // if (banner.Link.includes('https://screens-cf.doxxbet.sk') && $rootScope.ENV !== "localhost") {
      // 	// Manual rewrite banner url - points to localhost
      // 	banner.VideoLink = "http://localhost:8888" + banner.Link.split('https://screens-cf.doxxbet.sk')[1];
      // 	banner.Link = ""; // .Link directly binds to banner img element
      // } else {
      banner.VideoLink = banner.Link;
      // }
    }

    if (!banner.Type) banner.Type = $rootScope.settings.video.defaultType;
    return banner;
  };

  /**
   * Find if campaign is actual
   * @param start
   * @param end
   * @returns {boolean}
   */
  function actualCampaign(start, end) {
    var timestamp = moment().valueOf() - $rootScope.timeDiff,
      now = moment(timestamp).valueOf(),
      start = moment(start).valueOf(),
      end = moment(end).valueOf();

    //if (start > now || end < now) return false;
    //else return true;

    return start <= now && end >= now;
  }

  /**
   * Reformat banner structue
   * @param banner
   * @returns {*}
   */
  function reformatBanner(banner) {
    banner.show = false;
    var localeFix;
    switch ($rootScope.config.LanguageId) {
      case "fr":
      case "se":
        localeFix = "en";
        break;
      default:
        localeFix = $rootScope.config.LanguageId;
        break;
    }
    moment.locale(localeFix);

    // Handle non-available label in specified language for banner
    if (!banner.BannerDefinitions[$rootScope.config.LanguageId]) {
      if ($rootScope.config.Country === "SVK") {
        // Default language for labels on SVK farm is "sk"
        localeFix = "sk";
      } else {
        // Default language for labels on other farms than SVK is "en"
        localeFix = "en";
      }
    }
    // Reformat date
    if (banner && banner.BannerDefinitions) {

      if (banner.BannerDefinitions[localeFix] && banner.BannerDefinitions[localeFix].EventDate) {
        banner.customDate = moment(banner.BannerDefinitions[localeFix].EventDate).format("dddd, DD. MMMM,");
        banner.customTime = moment(banner.BannerDefinitions[localeFix].EventDate).format("HH:mm");
      }

      // Get sport, region, league of event
      if (banner.BannerDefinitions[localeFix] && banner.BannerDefinitions[localeFix].Tags) {
        var tempLocale = banner.BannerDefinitions[localeFix].Tags.split(";");
        banner.localization = {
          sport: tempLocale[0],
          region: tempLocale[1],
          league: tempLocale[2],
        };
      }

      // Parse competitors
      if (banner.BannerDefinitions[localeFix] && banner.BannerDefinitions[localeFix].EventName) {
        var tempCompetitors = banner.BannerDefinitions[localeFix].EventName.split(" vs. ");
        banner.competitors = {
          home: tempCompetitors[0],
          away: tempCompetitors[1],
        };
      }
      return banner;
    }
  }

  // Funkcia, ktora posiela data na spodnu obrazovku
  $rootScope.BottomScreen = function (key, data, backCall) {
    try {
      if (data) data = JSON.stringify(data);
        $rootScope.createLog(
        3,
        "ScreenApp_Calling_WebApp_STACK",
        [
        `key: ${key}
        data: ${JSON.stringify(data)}
        stack:${new Error().stack}`
        ].join("\n")
      );
      console.trace("ScreenApp_Calling_WebApp_STACK");
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: BottomScreen() { backCall === NoReturnValue } key: ' + key + ' data: ' + data + ' backCall: ' + backCall);
      // posielanie dat na spodnu obrazovku v browser mod
      $rootScope.config.DebugJsConsoleLogEnabled && window.opener && window.opener.postMessage({"key": key, "data": data}, "http://localhost:8080");
    } catch (err) {
      const stack = err instanceof Error ? err.stack : new Error().stack;
        $rootScope.createLog(
          3,
          "ScreenApp_Calling_WebApp_STACK_ERROR2",
          `key: ${key}
          data: ${JSON.stringify(data)}
          err: ${err}
          stack:${stack}`
        );
    }

    if (!backCall) {
      try {
        if (!data) {
          CallBottomScreen(key);
        } else {
          CallBottomScreen(key, data);
        }
      } catch (err) {
        const stack = err instanceof Error ? err.stack : new Error().stack;
        $rootScope.createLog(
          3,
          "ScreenApp_Calling_WebApp_STACK_ERROR3",
          [
            `key: ${key}`,
            `data: ${data}`,
            `err: ${String(err)}`,
            `stack: ${stack}`
          ].join("\n")
        );

        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: BottomScreen() key: ' + key + ' data: ' + JSON.stringify(data) + ' backCall: ' + backCall + ' err: ' + err);
      }
    } else {
      backCall = CallBottomScreen(key, data);
      if (backCall === "NoReturnValue") {
        var timeoutBottomScreenCall;
        clearTimeout(timeoutBottomScreenCall);
        timeoutBottomScreenCall = null;
        // Native app vykonava inu javascript funkciu
        timeoutBottomScreenCall = setTimeout(function () {
          // opakovanie volania
          CallBottomScreen(key, data, true);
        }, 100);
      } else {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: BottomScreen() { backCall !== NoReturnValue } key: ' + key + ' data: ' + JSON.stringify(data) + ' backCall: ' + backCall);
      }
      return false;
    }
  };

  $rootScope.closeAllWhenRestart = function () {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: closeAllWhenRestart()');
    $rootScope.hideAllExcept();
  };

  $rootScope.mediaDisableProtection = function (data) {
    try {
      // Cielom je po uplynuti casoveho intervalu pri necinnosti hraca vsetko vypnut (vratane QB, MT, VG)
      clearTimeout($scope.mediaDisableProtectionTimeout);
      $scope.mediaDisableProtectionTimeout = null;
      $scope.mediaDisableProtectionTimeout = setTimeout(function(data) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log("%c mediaDisableProtectionTimeout executed at " + Date() + " because of last action at " + data?.time + ", watcher timeout [s]: " +  $rootScope.config.MediaDisableProtectionTime /1000 , "background:tomato;padding:5px;color:yellow;");
        $rootScope.createLog(
        3,
        "mediaDisableProtectionTimeout executed at " + Date() +
        " because of last action at " + data?.time +
        ", watcher timeout [s]: " +  $rootScope.config.MediaDisableProtectionTime /1000,
        );
        $rootScope.hideAllExcept();
      }, $rootScope.config.MediaDisableProtectionTime, data);

      $rootScope.config.DebugJsConsoleLogEnabled && console.log("%c watcher called at "  + data?.time?.toString() +  ", watcher timeout [s]: " +  $rootScope.config.MediaDisableProtectionTime /1000 , "background:tomato;padding:5px;color:white;");
    } catch (e) {
      clearTimeout($scope.mediaDisableProtectionTimeout);
      $scope.mediaDisableProtectionTimeout = null;
      const errorMsg = e?.stack || e?.toString?.() || String(e);
      $rootScope.config.DebugJsConsoleLogEnabled && console.log(
      "mediaDisableProtectionTimeout executed at " + Date() +
      " because of last action at " + data?.time +
      ", watcher timeout [s]: " +  $rootScope.config.MediaDisableProtectionTime /1000 +
      " # ERROR: " + errorMsg
      );
      $rootScope.createLog(
      3,
      "mediaDisableProtectionTimeout",
      "watcher executed at " + Date() +
      " because of last action at " + data?.time +
      ", watcher timeout [s]: " +  $rootScope.config.MediaDisableProtectionTime /1000 +
      " # ERROR: " + errorMsg
      );
      $rootScope.hideAllExcept();
    }
  }

  $rootScope.createLogForStreamMedia = function (page, state) {
    var today = new Date(new Date().getTime());
    var date = today.getFullYear() + "-"
        + ("0" + (today.getMonth() + 1)).slice(-2) + "-"
        + ("0" + today.getDate()).slice(-2);
    var formatting = "padding:5px;color:white;";
    switch(page) {
      case "MT":
        formatting += "background:green;"
      break;
      case "VG":
        formatting += "background:blue;"
      break;
      case "QB":
        formatting += "background:red;"
      break;
    }

    // console.log("Date: " + date + " Time: " + today.toLocaleTimeString() + " %cPage: " + page + " " + state, formatting);
  }

  // Severity, Translation, Info
  $rootScope.createLog = function (logSev, logTrans, logInfo) {
    if (!logInfo) logInfo = "";
    setTimeout(function () {
      try {
        if (typeof WebAppError === 'function') {
          WebAppError(logSev, logTrans, logInfo);
        }
      } catch (err) {}
    }, 0);
  };

  // Zoznam komponentov ktore mozu byt zobrazene sucasne s ostanymi (komponenty/classy)
  $scope.nonConcurentBodyClasses = ['defaultBanner', 'vlc', 'video', 'jackpot'];
  $scope.lastConcurentBodyClasses = [];
  $rootScope.getBodyClass = function () {
    var allActiveShowSettings = [];
    allActiveShowSettings = Object.keys($rootScope.settings).filter(function (setting) {
      if ($rootScope.settings[setting]?.show) {
        return setting;
      }
    });
    if ($scope.nonConcurentBodyClasses?.length) {
      var concurentShowSettings = allActiveShowSettings.filter(function(t) {
          return !$scope.nonConcurentBodyClasses.includes(t);
      });
    }
    if (concurentShowSettings?.length >= 2 && (concurentShowSettings.toString() !== $scope.lastConcurentBodyClasses.toString())) {
      $scope.lastConcurentBodyClasses = concurentShowSettings;
      $rootScope.createLog(2, 'getBodyClass()','# ERROR: getBodyClass() concurentShowSettings: ' + concurentShowSettings.join());
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: getBodyClass() concurentShowSettings: ' + concurentShowSettings.join());
    }
    allActiveShowSettings.push($rootScope.resolution);
    return allActiveShowSettings;
  };

  // MatchTracker Setup
  (function (a, b, c, d, e, f, g, h, i) {
    a[e] ||
      ((i = a[e] =
        function () {
          (a[e].q = a[e].q || []).push(arguments);
        }),
      (i.l = 1 * new Date()),
      (i.o = f),
      (g = b.createElement(c)),
      (h = b.getElementsByTagName(c)[0]),
      (g.async = 1),
      (g.src = d),
      g.setAttribute("n", e),
      h.parentNode.insertBefore(g, h));
  })(window, document, "script", $rootScope.url.MatchtrackerURL + $rootScope.settings.matchTracker.clientID + "/widgetloader", "SIR", {
    theme: true, // using custom theme
    language: $rootScope.config.LanguageId,
  });

  // Zisťujem zmenu v tom, či je viditeľná iná obrazovka ako v podmienke
  $rootScope.$watch("settings", function() {
    $rootScope.topMostContent = '';
    angular.forEach($rootScope.settings, function(value, key) {
      if (key != 'defaultBanner' && key != 'vlc' && key != 'video') {
        if (value?.show == true) {
          $rootScope.topMostContent = key;
          $rootScope.hideVideo();
        } 
      }
    });
    // Zakomentovane koli logovaniu zapinania MT, VG a QB. (spotreba dat)
    // console.log("%cTopMost: " + $rootScope.topMostContent, "color:orange;background:blue;padding:5px");
  }, true);

  // Biometry libs load
  (function() {
    if ($rootScope.config.BiometryLogin) {
      // custom build od innovatrics verzia 8.0.2 
      // - povodny nazov suboru z package je index.mjs 
      // - premenovany na .js aby sedel mime type zo servra 
      // - je to v poriadku, lebo ho loadujeme ako modul iba tu a nijako inak sa s nim nepracuje
      ScriptLoaderService.load('lib/face-8.0.2-custombuild.js', 'module').then(function() {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: ScriptLoaderService.load() lib/face-8.0.2-custombuild.js success');
      }).catch(function(err) {
        $rootScope.createLog(2, 'ScriptLoaderService.load()', err.toString());
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: ScriptLoaderService.load() err: ' + err.toString());
      });
      // face-ui verzia 8.0.2 z dot-web-samples, ktora je kompatibilna s custom buildom od innovatrics
      ScriptLoaderService.load('lib/face-ui-8.0.2.js', 'module').then(function() {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: ScriptLoaderService.load() lib/face-ui-8.0.2.js success');
      }).catch(function(err) {
        $rootScope.createLog(2, 'ScriptLoaderService.load()', err.toString());
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: ScriptLoaderService.load() err: ' + err.toString());
      });
    } else {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: Biometry disabled BiometryLogin: ' + $rootScope.config.BiometryLogin);
    }

    if ($rootScope.config.BiometryOnboarding) {
      ScriptLoaderService.load('lib/document-7.5.0.js', 'module').then(function() {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: ScriptLoaderService.load() lib/document-7.5.0.js success');
      }).catch(function(err) {
        $rootScope.createLog(2, 'ScriptLoaderService.load()', err.toString());
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: ScriptLoaderService.load() err: ' + err.toString());
      });
      ScriptLoaderService.load('lib/document-ui-7.5.0.js', 'module').then(function() {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: ScriptLoaderService.load() lib/document-ui-7.5.0.js success');
      }).catch(function(err) {
        $rootScope.createLog(2, 'ScriptLoaderService.load()', err.toString());
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: ScriptLoaderService.load() err: ' + err.toString());
      });
    } else {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: Onboarding disabled BiometryOnboarding: ' + $rootScope.config.BiometryOnboarding);
    }
  })();

  // Initial setup on app start - posielam info na spodnu aby sa zavrel, ak je otvoreny vlc modal
  if ($rootScope.config.BiometryLogin || $rootScope.config.BiometryOnboarding) {
      $rootScope.BottomScreen("biometryAutentification", { state: "canceled" });
      //$rootScope.BottomScreen("biometryOnboarding", { state: "canceled" });
  };

  $rootScope.updateLabels();
  $rootScope.createLog(3, "TopScreenInit", "");
  $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: MainController { TopScreenInit }');
});
